import { render } from "./sti-list.vue?vue&type=template&id=65c0ddb4&ts=true"
import script from "./sti-list.vue?vue&type=script&lang=ts"
export * from "./sti-list.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__